export default {
  getAccountReportList: state => state.listGridData,
  getAccountChangesList: state => state.changesGridData,
};


// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountReport/accountReportGetter.js